import { SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_200_STROKE_DARK } from '@oneaudi/unified-web-alpha-common';
import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
 
  100% {
    opacity: 1;
  }
`;

export const Tile = styled.button<{ isSelected: boolean; isLoading: boolean; withBackground?: boolean }>`
	position: relative;
	width: 68px;
	height: 68px;
	padding: 4px;
	border-radius: 100%;
	animation: ${fadeIn} 0.8s ease;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		border-radius: 100%;
		width: 60px;
		object-fit: contain;
		height: 60px;
		${({ isLoading }) => `display: ${isLoading ? 'none' : 'inherit'};`}
	}

	${({ theme, withBackground }) =>
		withBackground &&
		`
			background: ${theme.sys.gradient.elevation.level3.fill};
		`}

	&:not(:disabled) {
		&:hover {
			outline: solid ${({ isSelected }) => (isSelected ? '2px' : '1px')};
			outline-color: ${SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_200_STROKE_DARK};
		}
		${({ isSelected }) =>
			isSelected &&
			`
			outline: solid 2px;
			outline-color: ${SYS_COLOR_SURFACE_INTERACTIVE_FORM_CONTROLS_DEFAULT_200_STROKE_DARK};
		`}
	}

	:disabled {
		img {
			opacity: 0.5;
		}
	}

	.progress-indicator {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		animation: unset !important;
	}
`;
